'use client';

import { c as _c } from "react/compiler-runtime";
import { PageJSON, TransformedNewsItem, Section } from '@/lib/types/pageBuilder';
import PageRenderer from './PageRenderer';
import ProgressivePageRenderer from './ProgressivePageRenderer';
import { DynamicTabInfo } from './TabBarSection';
import type { IncludeSectionApiData } from '@/lib/pageUtils';
interface DynamicPageProps {
  pageData: PageJSON;
  collectionsData: Map<string, TransformedNewsItem[]> | Record<string, TransformedNewsItem[]>;
  dynamicTabsMap?: Map<string, DynamicTabInfo[]> | Record<string, DynamicTabInfo[]>;
  includeSectionsData?: Map<string, Section> | Record<string, Section>;
  includeSectionApiData?: IncludeSectionApiData;
  sequentialLoading?: boolean;
  // Route params from dynamic URL (e.g., /treasure/{slug})
  routeParams?: {
    slug: string;
    displayName?: string;
  };
  // Data for page API bindings (keyed by binding ID)
  pageBindingsData?: Map<string, Record<string, unknown>> | Record<string, Record<string, unknown>>;
  // API data for pageHeading when sourceType is 'dynamic' with queryParams
  headingApiData?: Record<string, unknown>;
  // Data from double API calls (keyed by binding ID) - used when double_api_enabled is true
  doubleApiData?: Record<string, Record<string, unknown>>;
  // Pre-fetched data for progressive loading (server-side pre-fetch)
  prefetchedCollections?: Record<string, TransformedNewsItem[]>;
  prefetchedDynamicTabs?: Record<string, DynamicTabInfo[]>;
  prefetchedIncludeSections?: Record<string, Section>;
  prefetchedSectionIndices?: number[];
}
export default function DynamicPage(t0) {
  const $ = _c(26);
  const {
    pageData,
    collectionsData,
    dynamicTabsMap,
    includeSectionsData,
    includeSectionApiData,
    sequentialLoading: t1,
    pageBindingsData,
    headingApiData,
    doubleApiData,
    prefetchedCollections,
    prefetchedDynamicTabs,
    prefetchedIncludeSections,
    prefetchedSectionIndices
  } = t0;
  const sequentialLoading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== collectionsData) {
    t2 = collectionsData instanceof Map ? collectionsData : new Map(Object.entries(collectionsData));
    $[0] = collectionsData;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const dataMap = t2;
  let t3;
  if ($[2] !== dynamicTabsMap) {
    t3 = dynamicTabsMap ? dynamicTabsMap instanceof Map ? dynamicTabsMap : new Map(Object.entries(dynamicTabsMap)) : undefined;
    $[2] = dynamicTabsMap;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const tabsMap = t3;
  let t4;
  if ($[4] !== includeSectionsData) {
    t4 = includeSectionsData ? includeSectionsData instanceof Map ? includeSectionsData : new Map(Object.entries(includeSectionsData)) : undefined;
    $[4] = includeSectionsData;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const sectionsMap = t4;
  let t5;
  if ($[6] !== pageBindingsData) {
    t5 = pageBindingsData ? pageBindingsData instanceof Map ? pageBindingsData : new Map(Object.entries(pageBindingsData)) : undefined;
    $[6] = pageBindingsData;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const bindingsMap = t5;
  if (sequentialLoading) {
    let t6;
    if ($[8] !== headingApiData || $[9] !== pageData || $[10] !== prefetchedCollections || $[11] !== prefetchedDynamicTabs || $[12] !== prefetchedIncludeSections || $[13] !== prefetchedSectionIndices) {
      t6 = <ProgressivePageRenderer pageData={pageData} headingApiData={headingApiData} prefetchedCollections={prefetchedCollections} prefetchedDynamicTabs={prefetchedDynamicTabs} prefetchedIncludeSections={prefetchedIncludeSections} prefetchedSectionIndices={prefetchedSectionIndices} />;
      $[8] = headingApiData;
      $[9] = pageData;
      $[10] = prefetchedCollections;
      $[11] = prefetchedDynamicTabs;
      $[12] = prefetchedIncludeSections;
      $[13] = prefetchedSectionIndices;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  let t6;
  if ($[15] !== doubleApiData) {
    t6 = doubleApiData ? new Map(Object.entries(doubleApiData)) : undefined;
    $[15] = doubleApiData;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const doubleApiMap = t6;
  let t7;
  if ($[17] !== bindingsMap || $[18] !== dataMap || $[19] !== doubleApiMap || $[20] !== headingApiData || $[21] !== includeSectionApiData || $[22] !== pageData || $[23] !== sectionsMap || $[24] !== tabsMap) {
    t7 = <PageRenderer pageData={pageData} collectionsData={dataMap} dynamicTabsMap={tabsMap} includeSectionsData={sectionsMap} includeSectionApiData={includeSectionApiData} pageBindingsData={bindingsMap} headingApiData={headingApiData} doubleApiData={doubleApiMap} />;
    $[17] = bindingsMap;
    $[18] = dataMap;
    $[19] = doubleApiMap;
    $[20] = headingApiData;
    $[21] = includeSectionApiData;
    $[22] = pageData;
    $[23] = sectionsMap;
    $[24] = tabsMap;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}